//  the process key/value pair in docs.js specifies the process in which each document can be used
// this is the registry of the processes
const { pathOr } = require("ramda")

const vehicleProcess = {
  RENEWAL: "renewal",
  CHANGE_OWNER: "ownership",
  NEW_REG: "register",
  D_LICENSE: "driverslicense",
  ESTIMATE: "estimate",
}

const mapOrderTypeToTitle = (type) => {
  const orderTypeToTitle = {
    register: "New Registration",
    renewal: "Paper Renewal",
    ownership: "Change of Ownership",
    driverslicense: "Drivers Licence Renewal",
    estimate: "Estimate",
  }

  return pathOr(type, [type], orderTypeToTitle)
}

const orderAwaitingStatus = {
  NONE: "none",
  BIOMETRIC: "biometric",
  BIOMETRIC_PASSED: "biometric-passed",
  BIOMETRIC_FAILED: "biometric-failed",
}

const orderStages = {
  APPROVAL: "approval", //awaiting approval, like licences
  RECEIVED: "received",
  HOLD: "hold",
  PROCESS: "process",
  WAITING: "waiting",
  DELIVER: "deliver",
  COMPLETE: "complete",
  FAILED: "fail",
}

const TRANSACTION_TYPES = {
  payments: "payments",
  refunds: "refunds",
  commissions: "commissions",
  wallet: "wallet",
}

const emailGroupCategories = {
  allUsers: "allUsers",
  usersWithVehicles: "usersWithVehicles",
  usersWithCart: "usersWithCart",
  usersWithExpiredPapers: "usersWithExpiredPapers",
  usersWithMultipleVehicles: "usersWithMultipleVehicles",
}

module.exports = {
  vehicleProcess,
  orderAwaitingStatus,
  orderStages,
  TRANSACTION_TYPES,
  emailGroupCategories,
  mapOrderTypeToTitle,
}
